import { createSlice } from '@reduxjs/toolkit';
import { getHiddenDataNumber } from '../../../../domain/hidden-data-provider';
import { formatCartData } from '../../../shopping-cart/cart-bridger-pay/data/data-provider';
import { default as cloneDeep } from 'lodash/cloneDeep';
import { ICartData } from '../../../shopping-cart/cart-bridger-pay/interfaces';

interface IState {
    isOpened: boolean;
    isLoading: boolean;
    count: number;
    cartData?: ICartData|null;
    selectedItemGuid: string;
}

/**
 * initial state
 */
const initialState: IState = {
    isOpened: false,
    isLoading: true,
    count: getHiddenDataNumber('top-minicart-count') || 0,
    cartData: null,
    selectedItemGuid: '',
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setCartData(state, action) {
            return {
                ...state,
                cartData: formatCartData(cloneDeep(action.payload)),
            }
        },
    }
});

export default rootSlice;